export default __webpack_public_path__ + "static/media/shape.3ea1af47.png";